<!--
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: wjx
 * @Date: 2019-03-15 10:04:20
 * @LastEditTime: 2019-05-05 12:54:07
 -->
<template>
  <div class="academy-task-detail">
    <el-form :model="ruleForm" ref="ruleForm" label-width="150px" class="ruleForm" disabled>
      <div class="form-item">
        <el-form-item label="客户名称：">{{ruleForm.fullName}}</el-form-item>
        <el-form-item label="医院名称：">{{ruleForm.hospitalName}}</el-form-item>
      </div>
      <div class="form-item">
        <el-form-item label="医院等级：">{{ruleForm.gradeName}}</el-form-item>
        <el-form-item label="科室：">{{ruleForm.departmentName}}</el-form-item>
      </div>
      <div class="form-item">
        <el-form-item label="职称：">{{ruleForm.dutyName}}</el-form-item>
        <el-form-item label="拜访时间：">{{ruleForm.startDt}}</el-form-item>
      </div>
      <div class="form-item">
        <el-form-item label="拜访时长：">{{ruleForm.visitMinute}}分钟</el-form-item>
      </div>
      <el-form-item label="拜访地点：">
        <p>{{ruleForm.visitAddress}}</p>
        <img
          class="graph-pic"
          v-if="authType==1 || !authType"
          :src="ruleForm.addressPicUrl"
          alt
          @click="clickPic(ruleForm.addressPicUrl,null,false)"
        />
        <img
          v-else
          class="graph-pic"
          :src="ruleForm.addressWatermarkPicUrl"
          alt
          @click="clickPic(ruleForm.addressWatermarkPicUrl,null,false)"
        />
      </el-form-item>
      <el-form-item label="客户签名：" v-if="authType==1">
        <img
          class="graph-pic"
          @click="clickPic(ruleForm.autographPicUrl,null,false)"
          :src="ruleForm.autographPicUrl"
          alt
        />
      </el-form-item>
      <el-form-item label="现场照片：" v-if="authType!=1&&authType!=0">
        <div class="img-group">
          <img
            :src="item"
            alt
            v-for="(item,index) in ruleForm.pics"
            @click="clickPic(ruleForm.pics,index)"
            v-show="item!=='null'"
            :key="`pics${index}`"
          />
        </div>
      </el-form-item>
      <div class="form-item">
        <el-form-item label="传递信息：">{{ruleForm.messages}}</el-form-item>
        <el-form-item label="客户反馈：">{{ruleForm.customerRemark}}</el-form-item>
      </div>
      <div class="form-item">
        <el-form-item label="产品名称：">{{ruleForm.productName}}</el-form-item>
        <el-form-item label="产品剂型：">{{ruleForm.jixing}}</el-form-item>
      </div>
      <div class="form-item">
        <el-form-item label="产品规格：">{{ruleForm.guige}}</el-form-item>
        <el-form-item label="产品国药准字：">{{ruleForm.approvalNumber}}</el-form-item>
      </div>
    </el-form>
    <el-dialog :visible.sync="dialogVisible" width="60%">
      <div slot="title"></div>
      <el-carousel
        v-if="dialogVisible"
        trigger="click"
        height="45vh"
        :arrow="showArrow?'hover':'never'"
      >
        <el-carousel-item v-for="item in imagesList" :key="item">
          <img class="show-modal-ca" :src="item||'#'" alt />
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>
<script>
import { btLoading } from "@/Mixin/btLoading";
import { project } from "@/api/ajax";
import dicSelect from "@/components/Common/dicSelect.vue";
import UploadImgOne from "@/components/Common/UploadImgOne.vue";

export default {
  mixins: [btLoading],
  data() {
    return {
      showArrow: true,
      carouselIndex: 0,
      imagesList: [],
      authType: 0,
      dialogVisible: false,
      ruleForm: {
        enterpriseId: "",
        projectName: "",
        bgUrl: "",
        commonName: "",
        competitorList: [""],
        approvalNumber: "",
        guige: "",
        price: "",
        yuanPrice: ""
      },
      imgList: []
    };
  },
  components: {
    dicSelect,
    UploadImgOne
  },
  filters: {
    transStatus(val) {
      if (val == 1) {
        return "优秀";
      } else if (val == 2) {
        return "合格";
      } else if (val == 3) {
        return "不合格";
      }
    },
    transAuditStatus(val) {
      if (val == 1) {
        return "审核中";
      } else if (val == 2) {
        return "审核通过";
      } else if (val == 3) {
        return "审核未通过";
      }
    }
  },
  methods: {
    clickPic(scope, index, arrow) {
      // let property = scope || "";
      let target = scope;
      if (!Array.isArray(target)) {
        target = [target];
      }
      let curr = index;
      this.imagesList = target.filter((res, idx) => {
        if (!res || res === "null") {
          if (idx < curr) {
            curr--;
          }
        }
        return res && res !== "null";
      });
      this.dialogVisible = true;
      this.showArrow = this.imagesList.length > 1;
      this.carouselIndex = curr || 0;
    }
  },
  computed: {},
  watch: {},
  created() {
    if (this.$route.query.id) {
      let { detailId: id, authType, visitTime } = this.$route.query;
      this.authType = authType;
      project
        .hospitalTaskDetail({
          projectType: 9,
          id,
          authType,
          visitTime
        })
        .then(res => {
          const info = res.data.data[0];
          this.authType = info.authType;
          this.ruleForm = info;
        });
    }
  }
};
</script>
<style lang="scss">
.academy-task-detail {
  .el-form-item__label {
    color: #bfbfbf;
  }
}
</style>
<style lang="scss" scoped>
.modal-box {
  width: 100%;
  height: 100%;

  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
}

.graph-pic {
  margin-top: 13px;
  max-height: 132px;
}

.img-group {
  padding-top: 10px;
  display: flex;
  align-items: flex-start;

  img {
    max-height: 132px;
    margin-bottom: 15px;
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
}

.form-item {
  display: flex;
  max-width: 1000px;

  .el-form-item {
    width: 50%;
  }
}

.show-modal-ca {
  /*width: 100%!important;*/
  height: 100% !important;
  object-fit: contain !important;
}
</style>
